var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter, Input } from "@angular/core";
import { UsuarioService } from "../../services/usuario.service";
import { CommonService } from "../../services/common.service";
import { ExpedienteService } from "../../services/expediente.service";
import { Organismo } from "../../model/organismo";
import { Secretaria } from "../../model/secretaria";
var DatosIngresoComponent = (function () {
    function DatosIngresoComponent(_usrService, _expService, _comService) {
        this._usrService = _usrService;
        this._expService = _expService;
        this._comService = _comService;
        this.onComplete = new EventEmitter(false);
        this.conexo = false;
        this.ingreso = false;
        this.comboOrg = true;
        this.nro = '';
        this.anio = '';
        this.tex_cod = '';
        this.visibleMsg = false;
        this.verAceptar = true;
        this.esInc = false;
        this.aceptoExp = true;
    }
    DatosIngresoComponent.prototype.ngOnInit = function () {
        this.ingreso = this.ingDirecto;
    };
    DatosIngresoComponent.prototype.load = function () {
        var _this = this;
        this.validateTipoInc();
        this._expService.findTiposExpedienteIurix().subscribe(function (response) {
            _this.texList = response;
        });
        this._comService.findOrgForIngreso(this.fue, this.instancia, this.cir).subscribe(function (response) {
            _this.orgList = response;
        });
    };
    /*
    onChangeSelectOrg(newValue:number): void {
        this.orgSelected = this.orgList.find(item => item.orgId == newValue);
        if (this.orgSelected != undefined){
            this.secretaria = this.orgSelected.secretaria;
        }
        this.validateData();
    }
    */
    DatosIngresoComponent.prototype.onChangeSelectOrg = function (newValue) {
        var _a = newValue.split('|'), orgId = _a[0], depId = _a[1], sedDepId = _a[2];
        this.orgSelected = this.orgList.find(function (item) { return item.orgId == orgId && item.depId == depId && item.sedDepId == sedDepId; });
        //console.log("orgSelected "+this.orgSelected);
        if (this.orgSelected != undefined) {
            this.secretaria = this.orgSelected.secretaria;
        }
        this.validateData();
    };
    DatosIngresoComponent.prototype.onClickConexo = function (ev) {
        this.conexo = !this.conexo;
        //this.ingreso = false;  
        this.ingreso = (this.conexo) ? false : this.ingDirecto;
        //if (!this.conexo){
        this.blanquearForm();
        //}        
        this.validateData();
    };
    DatosIngresoComponent.prototype.blanquearForm = function () {
        this.nro = "";
        this.anio = "";
        this.tex_cod = "";
        this.comboOrg = true;
        this.expConexo = null;
        this.visibleMsg = false;
        this.secretaria = null;
        this.verAceptar = true;
        this.esInc = false;
        this.aceptoExp = true;
        this.orgSelected = new Organismo(0, '', null, null, null, null, null, null);
        this.hideErrorMsg();
    };
    DatosIngresoComponent.prototype.onClickIngreso = function (ev) {
        if (!this.conexo) {
            this.ingreso = !this.ingreso;
            this.comboOrg = true;
            this.validateData();
        }
    };
    DatosIngresoComponent.prototype.onChangeSelectTipo = function (selected) {
        this.tex_cod = selected;
    };
    DatosIngresoComponent.prototype.validateData = function () {
        // if (!this.ingreso && !this.conexo && !this.visibleMsg){            
        //     this.onComplete.emit(true);
        // }else{            
        //     if (this.conexo && this.expConexo !== undefined && this.expConexo != null && this.aceptoExp){
        //         this.onComplete.emit(true);        
        //     }else{
        //         this.onComplete.emit(false);
        //     }
        // }
        //console.log("validateData "+this.orgSelected);
        //console.log(this.conexo);
        if (this.orgSelected != undefined && this.orgSelected != null && this.orgSelected.orgId != 0) {
            this.onComplete.emit(true);
        }
        else {
            this.onComplete.emit(false);
        }
    };
    DatosIngresoComponent.prototype.validateTipoExp = function () {
        if (this.tex === 'EXP' && this.conexo) {
            this.verAceptar = true;
            // this.MsgTipos = "Ha elegido crear un tipo de expediente EXP, desea continuar? De caso contrario, vuelva a comenzar."; //this._comService.getConfiguracion("MSGCONEXP");
            this.MsgTipos = this._comService.getConfiguracion("MSGCONEXP");
            this.visibleMsg = true;
            this.aceptoExp = false;
        }
        this.validateData();
    };
    DatosIngresoComponent.prototype.validateTipoInc = function () {
        if (this.tex === 'INC') {
            this.verAceptar = false;
            // this.MsgTipos = "Ha elegido crear un tipo de expediente INC, seleccione el expediente conexo para continuar.";  //this._comService.getConfiguracion("MSGCONINC");      
            this.MsgTipos = this._comService.getConfiguracion("MSGCONINC");
            this.visibleMsg = true;
            //this.conexo = true;  
            this.esInc = true;
        }
        else {
            this.esInc = false;
        }
        this.validateData();
    };
    DatosIngresoComponent.prototype.onClickOK = function () {
        if (this.tex === 'EXP' && this.conexo) {
            this.visibleMsg = false;
            this.aceptoExp = true;
            this.validateData();
        }
    };
    DatosIngresoComponent.prototype.onClickBuscarConexo = function () {
        var _this = this;
        this.hideErrorMsg();
        if (this.tex_cod != '' && this.nro !== '' && this.anio !== '') {
            this._expService.findExpConexo(this.tex_cod, this.nro, this.anio).subscribe(function (response) {
                if (response.expId != null) {
                    _this.expConexo = response;
                    _this.secretaria = new Secretaria(_this.expConexo.secId, '', _this.expConexo.secretaria);
                    _this.orgSelected = new Organismo(_this.expConexo.orgId, '', _this.expConexo.organismo, null, _this.secretaria, null, null, null);
                    _this.comboOrg = false;
                    _this.validateTipoExp();
                }
                else {
                    _this.expConexo = null;
                    _this.secretaria = null;
                    _this.ErrorMsgB = "No se ha encontrado el Expediente solicitado.";
                    _this.ErrorMessageIsVisibleB = true;
                    _this.validateData();
                }
            }, function (error) {
                _this.expConexo = null;
                _this.secretaria = null;
                _this.ErrorMsgB = "No se ha encontrado el Expediente solicitado.";
                _this.ErrorMessageIsVisibleB = true;
                _this.validateData();
            });
        }
        else {
            this.ErrorMsgB = "Para buscar un Expediente conexo debe seleccionar el Tipo de Expediente, el Numero y Anio.";
            this.ErrorMessageIsVisibleB = true;
        }
    };
    DatosIngresoComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsgB = "";
        this.ErrorMessageIsVisibleB = false;
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    DatosIngresoComponent.prototype.onClickDirecto = function (ev) {
        if (!this.ingDirecto) {
            if (!this.conexo) {
                this.ingreso = !this.ingreso;
            }
        }
    };
    return DatosIngresoComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DatosIngresoComponent.prototype, "onComplete", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosIngresoComponent.prototype, "instancia", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosIngresoComponent.prototype, "cir", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosIngresoComponent.prototype, "fue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], DatosIngresoComponent.prototype, "tex", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], DatosIngresoComponent.prototype, "ingDirecto", void 0);
DatosIngresoComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'datos-ingreso',
        templateUrl: 'datos-ingreso.component.html',
    }),
    __metadata("design:paramtypes", [UsuarioService, ExpedienteService,
        CommonService])
], DatosIngresoComponent);
export { DatosIngresoComponent };
//# sourceMappingURL=datos-ingreso.component.js.map